import {
  EditGuesser,
  FieldGuesser,
  InputGuesser,
  ListGuesser,
} from "@api-platform/admin";
import { ReferenceArrayInput, SelectArrayInput } from "react-admin";
import { JsonInput } from "react-admin-json-view";

const CableFireHazardClassList = (props: any) => (
  <ListGuesser {...props}>
    <FieldGuesser source={"name"} />
    <FieldGuesser source={"title"} />
    <FieldGuesser source={"sortIndex"} />
  </ListGuesser>
);

const CableFireHazardClassEdit = (props: any) => (
  <EditGuesser {...props}>
    <InputGuesser source={"name"} />
    <InputGuesser source={"title"} />
    <InputGuesser source={"description"} />

    <ReferenceArrayInput source="insulations" reference="cable_insulations">
      <SelectArrayInput optionText="title" />
    </ReferenceArrayInput>

    <ReferenceArrayInput source="coreSections" reference="cable_core_sections">
      <SelectArrayInput optionText="area" />
    </ReferenceArrayInput>

    <JsonInput
      source={"textGenVars"}
      reactJsonOptions={{
        name: null,
        displayDataTypes: false,
        displayObjectSize: false,
        enableClipboard: false,
        onAdd: () => {},
      }}
    />
    <JsonInput
      source={"modelVars"}
      reactJsonOptions={{
        name: null,
        displayDataTypes: false,
        displayObjectSize: false,
        enableClipboard: false,
        defaultValue: "",
        onAdd: () => {},
      }}
    />
  </EditGuesser>
);

export { CableFireHazardClassList, CableFireHazardClassEdit };
